// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/icomoon.eot?nw7ib5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/icomoon.ttf?nw7ib5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/icomoon.woff?nw7ib5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/icomoon.svg?nw7ib5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@arvoreeducacao/bonsai-core/dist/fonts/iconcombo.ttf?g5kz9z", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'iconcombo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-sports-vol-2-trophy:before {
  content: '\\e9d3';
  color: #fff;
}
.icon-artes:before {
  content: '\\e991';
}
.icon-autoajuda:before {
  content: '\\e992';
}
.icon-autoestima:before {
  content: '\\e993';
}
.icon-biografias-e-autobiografias:before {
  content: '\\e994';
}
.icon-casa-e-lar:before {
  content: '\\e995';
}
.icon-ciencias-da-natureza:before {
  content: '\\e996';
}
.icon-ciencias-humanas-e-sociais:before {
  content: '\\e997';
}
.icon-contos:before {
  content: '\\e998';
}
.icon-dicionarios-e-referencia:before {
  content: '\\e999';
}
.icon-educacao:before {
  content: '\\e99a';
}
.icon-esoterismo:before {
  content: '\\e99b';
}
.icon-esportes-e-recreacao:before {
  content: '\\e99c';
}
.icon-fantasia:before {
  content: '\\e99d';
}
.icon-ficcao-cientifica:before {
  content: '\\e99e';
}
.icon-games:before {
  content: '\\e99f';
}
.icon-geografia:before {
  content: '\\e9a0';
}
.icon-historia:before {
  content: '\\e9a1';
}
.icon-historia-em-quadrinhos:before {
  content: '\\e9a2';
}
.icon-lendas-e-mitos:before {
  content: '\\e9a3';
}
.icon-lingua-portuguesa:before {
  content: '\\e9a4';
}
.icon-linguas-estrangeiras:before {
  content: '\\e9a5';
}
.icon-literatura:before {
  content: '\\e9a6';
}
.icon-literatura-infantojuvenil:before {
  content: '\\e9a7';
}
.icon-matematica:before {
  content: '\\e9a8';
}
.icon-misterio-policial-e-terror:before {
  content: '\\e9a9';
}
.icon-motivacional:before {
  content: '\\e9aa';
}
.icon-negocios-e-economia:before {
  content: '\\e9ab';
}
.icon-periodico-infantojuvenil:before {
  content: '\\e9ac';
}
.icon-periodicos:before {
  content: '\\e9ad';
}
.icon-religiao-e-espiritualidade:before {
  content: '\\e9ae';
}
.icon-romantico:before {
  content: '\\e9af';
}
.icon-saude-e-bem-estar:before {
  content: '\\e9b0';
}
.icon-tecnologia-e-engenharia:before {
  content: '\\e9b1';
}
.icon-viagem-e-turismo:before {
  content: '\\e9b2';
}
.icon-earth:before {
  content: '\\e978';
}
.icon-library_books:before {
  content: '\\e979';
}
.icon-line:before {
  content: '\\e97a';
}
.icon-grid:before {
  content: '\\e97b';
}
.icon-facebook:before {
  content: '\\e97c';
}
.icon-serif:before {
  content: '\\e97d';
}
.icon-sans:before {
  content: '\\e97e';
}
.icon-wifi_off:before {
  content: '\\e97f';
}
.icon-wifi:before {
  content: '\\e980';
}
.icon-copy:before {
  content: '\\e981';
}
.icon-delete:before {
  content: '\\e982';
}
.icon-favorite_broke:before {
  content: '\\e983';
}
.icon-local_movies:before {
  content: '\\e984';
}
.icon-layers_clear:before {
  content: '\\e985';
}
.icon-format_italic:before {
  content: '\\e986';
}
.icon-format_list_numbered:before {
  content: '\\e987';
}
.icon-format_bold:before {
  content: '\\e988';
}
.icon-insert_link:before {
  content: '\\e989';
}
.icon-format_underlined:before {
  content: '\\e98a';
}
.icon-format_align_right:before {
  content: '\\e98b';
}
.icon-format_align_left:before {
  content: '\\e98c';
}
.icon-format_align_justify:before {
  content: '\\e98d';
}
.icon-format_align_center:before {
  content: '\\e98e';
}
.icon-insert_photo:before {
  content: '\\e98f';
}
.icon-show_chart_24px:before {
  content: '\\e990';
}
.icon-local_library:before {
  content: '\\e900';
}
.icon-local_printshop:before {
  content: '\\e901';
}
.icon-zoom_out_map:before {
  content: '\\e902';
}
.icon-headset:before {
  content: '\\e903';
}
.icon-keyboard_arrow_down:before {
  content: '\\e904';
}
.icon-cloud_done:before {
  content: '\\e905';
}
.icon-format_list_bulleted:before {
  content: '\\e906';
}
.icon-format_size:before {
  content: '\\e907';
}
.icon-title:before {
  content: '\\e908';
}
.icon-add_circle_outline:before {
  content: '\\e909';
}
.icon-add_circle:before {
  content: '\\e90a';
}
.icon-add:before {
  content: '\\e90b';
}
.icon-clear:before {
  content: '\\e90c';
}
.icon-create:before {
  content: '\\e90d';
}
.icon-outlined_flag:before {
  content: '\\e90e';
}
.icon-remove_circle:before {
  content: '\\e90f';
}
.icon-report:before {
  content: '\\e910';
}
.icon-filter_list_sharp:before {
  content: '\\e911';
}
.icon-forum:before {
  content: '\\e912';
}
.icon-equalizer:before {
  content: '\\e913';
}
.icon-error_outline:before {
  content: '\\e914';
}
.icon-error:before {
  content: '\\e915';
}
.icon-notification_important:before {
  content: '\\e916';
}
.icon-warning_amber:before {
  content: '\\e917';
}
.icon-warning:before {
  content: '\\e918';
}
.icon-check_box_outline_blank:before {
  content: '\\e919';
}
.icon-check_box:before {
  content: '\\e91a';
}
.icon-indeterminate_check_box:before {
  content: '\\e91b';
}
.icon-radio_button_checked:before {
  content: '\\e91c';
}
.icon-radio_button_unchecked:before {
  content: '\\e91d';
}
.icon-star_border_purple500:before {
  content: '\\e91e';
}
.icon-star_border:before {
  content: '\\e91f';
}
.icon-star_half:before {
  content: '\\e920';
}
.icon-star_outline:before {
  content: '\\e921';
}
.icon-star_purple500:before {
  content: '\\e922';
}
.icon-star:before {
  content: '\\e923';
}
.icon-group_add:before {
  content: '\\e924';
}
.icon-group:before {
  content: '\\e925';
}
.icon-notifications_active:before {
  content: '\\e926';
}
.icon-notifications_none:before {
  content: '\\e927';
}
.icon-notifications_off:before {
  content: '\\e928';
}
.icon-notifications:before {
  content: '\\e929';
}
.icon-people_outline:before {
  content: '\\e92a';
}
.icon-people:before {
  content: '\\e92b';
}
.icon-person_add:before {
  content: '\\e92c';
}
.icon-person_outline:before {
  content: '\\e92d';
}
.icon-person:before {
  content: '\\e92e';
}
.icon-school:before {
  content: '\\e92f';
}
.icon-share:before {
  content: '\\e930';
}
.icon-arrow_right:before {
  content: '\\e931';
}
.icon-arrow_upward:before {
  content: '\\e932';
}
.icon-cancel:before {
  content: '\\e933';
}
.icon-check:before {
  content: '\\e934';
}
.icon-chevron_left:before {
  content: '\\e935';
}
.icon-chevron_right:before {
  content: '\\e936';
}
.icon-close:before {
  content: '\\e937';
}
.icon-expand_less:before {
  content: '\\e938';
}
.icon-expand_more:before {
  content: '\\e939';
}
.icon-fullscreen_exit:before {
  content: '\\e93a';
}
.icon-fullscreen:before {
  content: '\\e93b';
}
.icon-more_horiz:before {
  content: '\\e93c';
}
.icon-more_vert:before {
  content: '\\e93d';
}
.icon-unfold_more:before {
  content: '\\e93e';
}
.icon-apps:before {
  content: '\\e93f';
}
.icon-arrow_back_ios:before {
  content: '\\e940';
}
.icon-arrow_back:before {
  content: '\\e941';
}
.icon-arrow_downward:before {
  content: '\\e942';
}
.icon-arrow_drop_down:before {
  content: '\\e943';
}
.icon-arrow_drop_up:before {
  content: '\\e944';
}
.icon-arrow_forward_ios:before {
  content: '\\e945';
}
.icon-arrow_forward:before {
  content: '\\e946';
}
.icon-arrow_left:before {
  content: '\\e947';
}
.icon-brightness_2_outlined:before {
  content: '\\e948';
}
.icon-brightness_4_outlined:before {
  content: '\\e949';
}
.icon-brightness_5_outlined:before {
  content: '\\e94a';
}
.icon-control_point:before {
  content: '\\e94b';
}
.icon-picture_as_pdf:before {
  content: '\\e94c';
}
.icon-account_circle_sharp:before {
  content: '\\e94d';
}
.icon-calendar_today_sharp:before {
  content: '\\e94e';
}
.icon-lightbulb_outline:before {
  content: '\\e94f';
}
.icon-lock_open:before {
  content: '\\e950';
}
.icon-lock_outline:before {
  content: '\\e951';
}
.icon-lock:before {
  content: '\\e952';
}
.icon-offline_bolt:before {
  content: '\\e953';
}
.icon-perm_identity:before {
  content: '\\e954';
}
.icon-power_settings_new:before {
  content: '\\e955';
}
.icon-print:before {
  content: '\\e956';
}
.icon-query_builder:before {
  content: '\\e957';
}
.icon-question_answer:before {
  content: '\\e958';
}
.icon-record_voice_over:before {
  content: '\\e959';
}
.icon-search:before {
  content: '\\e95a';
}
.icon-settings:before {
  content: '\\e95b';
}
.icon-supervisor_account:before {
  content: '\\e95c';
}
.icon-swap_horiz:before {
  content: '\\e95d';
}
.icon-swap_vert:before {
  content: '\\e95e';
}
.icon-turned_in_not:before {
  content: '\\e95f';
}
.icon-turned_in:before {
  content: '\\e960';
}
.icon-visibility_off:before {
  content: '\\e961';
}
.icon-visibility:before {
  content: '\\e962';
}
.icon-zoom_in:before {
  content: '\\e963';
}
.icon-zoom_out:before {
  content: '\\e964';
}
.icon-assignment:before {
  content: '\\e965';
}
.icon-autorenew:before {
  content: '\\e966';
}
.icon-book:before {
  content: '\\e967';
}
.icon-bookmark:before {
  content: '\\e968';
}
.icon-bookmarks:before {
  content: '\\e969';
}
.icon-check_circle_outline:before {
  content: '\\e96a';
}
.icon-check_circle:before {
  content: '\\e96b';
}
.icon-contact_support:before {
  content: '\\e96c';
}
.icon-delete_forever:before {
  content: '\\e96d';
}
.icon-done:before {
  content: '\\e96e';
}
.icon-drag_indicator:before {
  content: '\\e96f';
}
.icon-favorite_border:before {
  content: '\\e970';
}
.icon-favorite:before {
  content: '\\e971';
}
.icon-help_outline:before {
  content: '\\e972';
}
.icon-help:before {
  content: '\\e973';
}
.icon-highlight_off:before {
  content: '\\e974';
}
.icon-home:before {
  content: '\\e975';
}
.icon-info_outline:before {
  content: '\\e976';
}
.icon-info:before {
  content: '\\e977';
}
.icon-like_on:before {
  content: '\\e9d0';
}
.icon-like_off:before {
  content: '\\e9d1';
  color: #9eaeb7;
}
.icon-filter_list:before {
  content: '\\e9d2';
}
.icon-semente .path1:before {
  content: '\\e9d4';
  color: rgb(219, 245, 242);
}
.icon-semente .path2:before {
  content: '\\e9d5';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_pequena .path1:before {
  content: '\\e9d6';
  color: rgb(219, 245, 242);
}
.icon-arvore_pequena .path2:before {
  content: '\\e9d7';
  margin-left: -1em;
  color: rgb(26, 61, 50);
}
.icon-arvore_pequena .path3:before {
  content: '\\e9d8';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_pequena .path4:before {
  content: '\\e9d9';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_pequena .path5:before {
  content: '\\e9da';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_media .path1:before {
  content: '\\e9db';
  color: rgb(219, 245, 242);
}
.icon-arvore_media .path2:before {
  content: '\\e9dc';
  margin-left: -1em;
  color: rgb(26, 61, 50);
}
.icon-arvore_media .path3:before {
  content: '\\e9dd';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_media .path4:before {
  content: '\\e9de';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_media .path5:before {
  content: '\\e9df';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_media .path6:before {
  content: '\\e9e0';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_media .path7:before {
  content: '\\e9e1';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_grande .path1:before {
  content: '\\e9e2';
  color: rgb(219, 245, 242);
}
.icon-arvore_grande .path2:before {
  content: '\\e9e3';
  margin-left: -1em;
  color: rgb(26, 61, 50);
}
.icon-arvore_grande .path3:before {
  content: '\\e9e4';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-arvore_grande .path4:before {
  content: '\\e9e5';
  margin-left: -1em;
  color: rgb(81, 165, 27);
}
.icon-sementes .path1:before {
  content: '\\e9b3';
  color: rgb(70, 120, 70);
}
.icon-sementes .path2:before {
  content: '\\e9b4';
  margin-left: -1em;
  color: rgb(70, 120, 70);
}
.icon-sementes .path3:before {
  content: '\\e9b5';
  margin-left: -1em;
  color: rgb(140, 190, 60);
}
.icon-sementes .path4:before {
  content: '\\e9b6';
  margin-left: -1em;
  color: rgb(140, 190, 60);
}
.icon-pontos .path1:before {
  content: '\\e9b7';
  color: rgb(214, 186, 241);
}
.icon-pontos .path2:before {
  content: '\\e9b8';
  margin-left: -1em;
  color: rgb(169, 126, 209);
}
.icon-moedas .path1:before {
  content: '\\e9b9';
  color: rgb(255, 227, 177);
}
.icon-moedas .path2:before {
  content: '\\e9ba';
  margin-left: -1em;
  color: rgb(255, 197, 23);
}
.icon-moedas .path3:before {
  content: '\\e9bb';
  margin-left: -1em;
  color: rgb(255, 227, 177);
}
.icon-especiais .path1:before {
  content: '\\e9bc';
  color: rgb(178, 180, 185);
}
.icon-especiais .path2:before {
  content: '\\e9bd';
  margin-left: -1em;
  color: rgb(190, 190, 190);
}
.icon-especiais .path3:before {
  content: '\\e9be';
  margin-left: -1em;
  color: rgb(190, 190, 190);
}
.icon-especiais .path4:before {
  content: '\\e9bf';
  margin-left: -1em;
  color: rgb(178, 180, 185);
}
.icon-especiais .path5:before {
  content: '\\e9c0';
  margin-left: -1em;
  color: rgb(178, 180, 185);
}
.icon-especiais .path6:before {
  content: '\\e9c1';
  margin-left: -1em;
  color: rgb(255, 248, 236);
}
.icon-especiais .path7:before {
  content: '\\e9c2';
  margin-left: -1em;
  color: rgb(255, 248, 236);
}
.icon-especiais .path8:before {
  content: '\\e9c3';
  margin-left: -1em;
  color: rgb(255, 197, 23);
}
.icon-especiais .path9:before {
  content: '\\e9c4';
  margin-left: -1em;
  color: rgb(0, 0, 0);
}
.icon-especiais .path10:before {
  content: '\\e9c5';
  margin-left: -1em;
  color: rgb(89, 90, 92);
}
.icon-especiais .path11:before {
  content: '\\e9c6';
  margin-left: -1em;
  color: rgb(89, 90, 92);
}
.icon-especiais .path12:before {
  content: '\\e9c7';
  margin-left: -1em;
  color: rgb(89, 90, 92);
}
.icon-bloqueado .path1:before {
  content: '\\e9c8';
  color: rgb(155, 230, 222);
}
.icon-bloqueado .path2:before {
  content: '\\e9c9';
  margin-left: -1em;
  color: rgb(69, 208, 193);
}
.icon-bloqueado .path3:before {
  content: '\\e9ca';
  margin-left: -1em;
  color: rgb(219, 246, 243);
}
.icon-amigos .path1:before {
  content: '\\e9cb';
  color: rgb(155, 230, 222);
}
.icon-amigos .path2:before {
  content: '\\e9cc';
  margin-left: -1em;
  color: rgb(155, 230, 222);
}
.icon-amigos .path3:before {
  content: '\\e9cd';
  margin-left: -1em;
  color: rgb(69, 208, 193);
}
.icon-amigos .path4:before {
  content: '\\e9ce';
  margin-left: -1em;
  color: rgb(69, 208, 193);
}
.icon-agua:before {
  content: '\\e9cf';
  color: #76d3f9;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global/icons.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAuC;EACvC;;;yDAG0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src: url('../fonts/icomoon.eot?nw7ib5');\n  src: url('../fonts/icomoon.eot?nw7ib5#iefix') format('embedded-opentype'),\n    url('../fonts/icomoon.ttf?nw7ib5') format('truetype'),\n    url('../fonts/icomoon.woff?nw7ib5') format('woff'),\n    url('../fonts/icomoon.svg?nw7ib5#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'iconcombo';\n  src: url('~@arvoreeducacao/bonsai-core/dist/fonts/iconcombo.ttf?g5kz9z')\n    format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^='icon-'],\n[class*=' icon-'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-sports-vol-2-trophy:before {\n  content: '\\e9d3';\n  color: #fff;\n}\n.icon-artes:before {\n  content: '\\e991';\n}\n.icon-autoajuda:before {\n  content: '\\e992';\n}\n.icon-autoestima:before {\n  content: '\\e993';\n}\n.icon-biografias-e-autobiografias:before {\n  content: '\\e994';\n}\n.icon-casa-e-lar:before {\n  content: '\\e995';\n}\n.icon-ciencias-da-natureza:before {\n  content: '\\e996';\n}\n.icon-ciencias-humanas-e-sociais:before {\n  content: '\\e997';\n}\n.icon-contos:before {\n  content: '\\e998';\n}\n.icon-dicionarios-e-referencia:before {\n  content: '\\e999';\n}\n.icon-educacao:before {\n  content: '\\e99a';\n}\n.icon-esoterismo:before {\n  content: '\\e99b';\n}\n.icon-esportes-e-recreacao:before {\n  content: '\\e99c';\n}\n.icon-fantasia:before {\n  content: '\\e99d';\n}\n.icon-ficcao-cientifica:before {\n  content: '\\e99e';\n}\n.icon-games:before {\n  content: '\\e99f';\n}\n.icon-geografia:before {\n  content: '\\e9a0';\n}\n.icon-historia:before {\n  content: '\\e9a1';\n}\n.icon-historia-em-quadrinhos:before {\n  content: '\\e9a2';\n}\n.icon-lendas-e-mitos:before {\n  content: '\\e9a3';\n}\n.icon-lingua-portuguesa:before {\n  content: '\\e9a4';\n}\n.icon-linguas-estrangeiras:before {\n  content: '\\e9a5';\n}\n.icon-literatura:before {\n  content: '\\e9a6';\n}\n.icon-literatura-infantojuvenil:before {\n  content: '\\e9a7';\n}\n.icon-matematica:before {\n  content: '\\e9a8';\n}\n.icon-misterio-policial-e-terror:before {\n  content: '\\e9a9';\n}\n.icon-motivacional:before {\n  content: '\\e9aa';\n}\n.icon-negocios-e-economia:before {\n  content: '\\e9ab';\n}\n.icon-periodico-infantojuvenil:before {\n  content: '\\e9ac';\n}\n.icon-periodicos:before {\n  content: '\\e9ad';\n}\n.icon-religiao-e-espiritualidade:before {\n  content: '\\e9ae';\n}\n.icon-romantico:before {\n  content: '\\e9af';\n}\n.icon-saude-e-bem-estar:before {\n  content: '\\e9b0';\n}\n.icon-tecnologia-e-engenharia:before {\n  content: '\\e9b1';\n}\n.icon-viagem-e-turismo:before {\n  content: '\\e9b2';\n}\n.icon-earth:before {\n  content: '\\e978';\n}\n.icon-library_books:before {\n  content: '\\e979';\n}\n.icon-line:before {\n  content: '\\e97a';\n}\n.icon-grid:before {\n  content: '\\e97b';\n}\n.icon-facebook:before {\n  content: '\\e97c';\n}\n.icon-serif:before {\n  content: '\\e97d';\n}\n.icon-sans:before {\n  content: '\\e97e';\n}\n.icon-wifi_off:before {\n  content: '\\e97f';\n}\n.icon-wifi:before {\n  content: '\\e980';\n}\n.icon-copy:before {\n  content: '\\e981';\n}\n.icon-delete:before {\n  content: '\\e982';\n}\n.icon-favorite_broke:before {\n  content: '\\e983';\n}\n.icon-local_movies:before {\n  content: '\\e984';\n}\n.icon-layers_clear:before {\n  content: '\\e985';\n}\n.icon-format_italic:before {\n  content: '\\e986';\n}\n.icon-format_list_numbered:before {\n  content: '\\e987';\n}\n.icon-format_bold:before {\n  content: '\\e988';\n}\n.icon-insert_link:before {\n  content: '\\e989';\n}\n.icon-format_underlined:before {\n  content: '\\e98a';\n}\n.icon-format_align_right:before {\n  content: '\\e98b';\n}\n.icon-format_align_left:before {\n  content: '\\e98c';\n}\n.icon-format_align_justify:before {\n  content: '\\e98d';\n}\n.icon-format_align_center:before {\n  content: '\\e98e';\n}\n.icon-insert_photo:before {\n  content: '\\e98f';\n}\n.icon-show_chart_24px:before {\n  content: '\\e990';\n}\n.icon-local_library:before {\n  content: '\\e900';\n}\n.icon-local_printshop:before {\n  content: '\\e901';\n}\n.icon-zoom_out_map:before {\n  content: '\\e902';\n}\n.icon-headset:before {\n  content: '\\e903';\n}\n.icon-keyboard_arrow_down:before {\n  content: '\\e904';\n}\n.icon-cloud_done:before {\n  content: '\\e905';\n}\n.icon-format_list_bulleted:before {\n  content: '\\e906';\n}\n.icon-format_size:before {\n  content: '\\e907';\n}\n.icon-title:before {\n  content: '\\e908';\n}\n.icon-add_circle_outline:before {\n  content: '\\e909';\n}\n.icon-add_circle:before {\n  content: '\\e90a';\n}\n.icon-add:before {\n  content: '\\e90b';\n}\n.icon-clear:before {\n  content: '\\e90c';\n}\n.icon-create:before {\n  content: '\\e90d';\n}\n.icon-outlined_flag:before {\n  content: '\\e90e';\n}\n.icon-remove_circle:before {\n  content: '\\e90f';\n}\n.icon-report:before {\n  content: '\\e910';\n}\n.icon-filter_list_sharp:before {\n  content: '\\e911';\n}\n.icon-forum:before {\n  content: '\\e912';\n}\n.icon-equalizer:before {\n  content: '\\e913';\n}\n.icon-error_outline:before {\n  content: '\\e914';\n}\n.icon-error:before {\n  content: '\\e915';\n}\n.icon-notification_important:before {\n  content: '\\e916';\n}\n.icon-warning_amber:before {\n  content: '\\e917';\n}\n.icon-warning:before {\n  content: '\\e918';\n}\n.icon-check_box_outline_blank:before {\n  content: '\\e919';\n}\n.icon-check_box:before {\n  content: '\\e91a';\n}\n.icon-indeterminate_check_box:before {\n  content: '\\e91b';\n}\n.icon-radio_button_checked:before {\n  content: '\\e91c';\n}\n.icon-radio_button_unchecked:before {\n  content: '\\e91d';\n}\n.icon-star_border_purple500:before {\n  content: '\\e91e';\n}\n.icon-star_border:before {\n  content: '\\e91f';\n}\n.icon-star_half:before {\n  content: '\\e920';\n}\n.icon-star_outline:before {\n  content: '\\e921';\n}\n.icon-star_purple500:before {\n  content: '\\e922';\n}\n.icon-star:before {\n  content: '\\e923';\n}\n.icon-group_add:before {\n  content: '\\e924';\n}\n.icon-group:before {\n  content: '\\e925';\n}\n.icon-notifications_active:before {\n  content: '\\e926';\n}\n.icon-notifications_none:before {\n  content: '\\e927';\n}\n.icon-notifications_off:before {\n  content: '\\e928';\n}\n.icon-notifications:before {\n  content: '\\e929';\n}\n.icon-people_outline:before {\n  content: '\\e92a';\n}\n.icon-people:before {\n  content: '\\e92b';\n}\n.icon-person_add:before {\n  content: '\\e92c';\n}\n.icon-person_outline:before {\n  content: '\\e92d';\n}\n.icon-person:before {\n  content: '\\e92e';\n}\n.icon-school:before {\n  content: '\\e92f';\n}\n.icon-share:before {\n  content: '\\e930';\n}\n.icon-arrow_right:before {\n  content: '\\e931';\n}\n.icon-arrow_upward:before {\n  content: '\\e932';\n}\n.icon-cancel:before {\n  content: '\\e933';\n}\n.icon-check:before {\n  content: '\\e934';\n}\n.icon-chevron_left:before {\n  content: '\\e935';\n}\n.icon-chevron_right:before {\n  content: '\\e936';\n}\n.icon-close:before {\n  content: '\\e937';\n}\n.icon-expand_less:before {\n  content: '\\e938';\n}\n.icon-expand_more:before {\n  content: '\\e939';\n}\n.icon-fullscreen_exit:before {\n  content: '\\e93a';\n}\n.icon-fullscreen:before {\n  content: '\\e93b';\n}\n.icon-more_horiz:before {\n  content: '\\e93c';\n}\n.icon-more_vert:before {\n  content: '\\e93d';\n}\n.icon-unfold_more:before {\n  content: '\\e93e';\n}\n.icon-apps:before {\n  content: '\\e93f';\n}\n.icon-arrow_back_ios:before {\n  content: '\\e940';\n}\n.icon-arrow_back:before {\n  content: '\\e941';\n}\n.icon-arrow_downward:before {\n  content: '\\e942';\n}\n.icon-arrow_drop_down:before {\n  content: '\\e943';\n}\n.icon-arrow_drop_up:before {\n  content: '\\e944';\n}\n.icon-arrow_forward_ios:before {\n  content: '\\e945';\n}\n.icon-arrow_forward:before {\n  content: '\\e946';\n}\n.icon-arrow_left:before {\n  content: '\\e947';\n}\n.icon-brightness_2_outlined:before {\n  content: '\\e948';\n}\n.icon-brightness_4_outlined:before {\n  content: '\\e949';\n}\n.icon-brightness_5_outlined:before {\n  content: '\\e94a';\n}\n.icon-control_point:before {\n  content: '\\e94b';\n}\n.icon-picture_as_pdf:before {\n  content: '\\e94c';\n}\n.icon-account_circle_sharp:before {\n  content: '\\e94d';\n}\n.icon-calendar_today_sharp:before {\n  content: '\\e94e';\n}\n.icon-lightbulb_outline:before {\n  content: '\\e94f';\n}\n.icon-lock_open:before {\n  content: '\\e950';\n}\n.icon-lock_outline:before {\n  content: '\\e951';\n}\n.icon-lock:before {\n  content: '\\e952';\n}\n.icon-offline_bolt:before {\n  content: '\\e953';\n}\n.icon-perm_identity:before {\n  content: '\\e954';\n}\n.icon-power_settings_new:before {\n  content: '\\e955';\n}\n.icon-print:before {\n  content: '\\e956';\n}\n.icon-query_builder:before {\n  content: '\\e957';\n}\n.icon-question_answer:before {\n  content: '\\e958';\n}\n.icon-record_voice_over:before {\n  content: '\\e959';\n}\n.icon-search:before {\n  content: '\\e95a';\n}\n.icon-settings:before {\n  content: '\\e95b';\n}\n.icon-supervisor_account:before {\n  content: '\\e95c';\n}\n.icon-swap_horiz:before {\n  content: '\\e95d';\n}\n.icon-swap_vert:before {\n  content: '\\e95e';\n}\n.icon-turned_in_not:before {\n  content: '\\e95f';\n}\n.icon-turned_in:before {\n  content: '\\e960';\n}\n.icon-visibility_off:before {\n  content: '\\e961';\n}\n.icon-visibility:before {\n  content: '\\e962';\n}\n.icon-zoom_in:before {\n  content: '\\e963';\n}\n.icon-zoom_out:before {\n  content: '\\e964';\n}\n.icon-assignment:before {\n  content: '\\e965';\n}\n.icon-autorenew:before {\n  content: '\\e966';\n}\n.icon-book:before {\n  content: '\\e967';\n}\n.icon-bookmark:before {\n  content: '\\e968';\n}\n.icon-bookmarks:before {\n  content: '\\e969';\n}\n.icon-check_circle_outline:before {\n  content: '\\e96a';\n}\n.icon-check_circle:before {\n  content: '\\e96b';\n}\n.icon-contact_support:before {\n  content: '\\e96c';\n}\n.icon-delete_forever:before {\n  content: '\\e96d';\n}\n.icon-done:before {\n  content: '\\e96e';\n}\n.icon-drag_indicator:before {\n  content: '\\e96f';\n}\n.icon-favorite_border:before {\n  content: '\\e970';\n}\n.icon-favorite:before {\n  content: '\\e971';\n}\n.icon-help_outline:before {\n  content: '\\e972';\n}\n.icon-help:before {\n  content: '\\e973';\n}\n.icon-highlight_off:before {\n  content: '\\e974';\n}\n.icon-home:before {\n  content: '\\e975';\n}\n.icon-info_outline:before {\n  content: '\\e976';\n}\n.icon-info:before {\n  content: '\\e977';\n}\n.icon-like_on:before {\n  content: '\\e9d0';\n}\n.icon-like_off:before {\n  content: '\\e9d1';\n  color: #9eaeb7;\n}\n.icon-filter_list:before {\n  content: '\\e9d2';\n}\n.icon-semente .path1:before {\n  content: '\\e9d4';\n  color: rgb(219, 245, 242);\n}\n.icon-semente .path2:before {\n  content: '\\e9d5';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_pequena .path1:before {\n  content: '\\e9d6';\n  color: rgb(219, 245, 242);\n}\n.icon-arvore_pequena .path2:before {\n  content: '\\e9d7';\n  margin-left: -1em;\n  color: rgb(26, 61, 50);\n}\n.icon-arvore_pequena .path3:before {\n  content: '\\e9d8';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_pequena .path4:before {\n  content: '\\e9d9';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_pequena .path5:before {\n  content: '\\e9da';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_media .path1:before {\n  content: '\\e9db';\n  color: rgb(219, 245, 242);\n}\n.icon-arvore_media .path2:before {\n  content: '\\e9dc';\n  margin-left: -1em;\n  color: rgb(26, 61, 50);\n}\n.icon-arvore_media .path3:before {\n  content: '\\e9dd';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_media .path4:before {\n  content: '\\e9de';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_media .path5:before {\n  content: '\\e9df';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_media .path6:before {\n  content: '\\e9e0';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_media .path7:before {\n  content: '\\e9e1';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_grande .path1:before {\n  content: '\\e9e2';\n  color: rgb(219, 245, 242);\n}\n.icon-arvore_grande .path2:before {\n  content: '\\e9e3';\n  margin-left: -1em;\n  color: rgb(26, 61, 50);\n}\n.icon-arvore_grande .path3:before {\n  content: '\\e9e4';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-arvore_grande .path4:before {\n  content: '\\e9e5';\n  margin-left: -1em;\n  color: rgb(81, 165, 27);\n}\n.icon-sementes .path1:before {\n  content: '\\e9b3';\n  color: rgb(70, 120, 70);\n}\n.icon-sementes .path2:before {\n  content: '\\e9b4';\n  margin-left: -1em;\n  color: rgb(70, 120, 70);\n}\n.icon-sementes .path3:before {\n  content: '\\e9b5';\n  margin-left: -1em;\n  color: rgb(140, 190, 60);\n}\n.icon-sementes .path4:before {\n  content: '\\e9b6';\n  margin-left: -1em;\n  color: rgb(140, 190, 60);\n}\n.icon-pontos .path1:before {\n  content: '\\e9b7';\n  color: rgb(214, 186, 241);\n}\n.icon-pontos .path2:before {\n  content: '\\e9b8';\n  margin-left: -1em;\n  color: rgb(169, 126, 209);\n}\n.icon-moedas .path1:before {\n  content: '\\e9b9';\n  color: rgb(255, 227, 177);\n}\n.icon-moedas .path2:before {\n  content: '\\e9ba';\n  margin-left: -1em;\n  color: rgb(255, 197, 23);\n}\n.icon-moedas .path3:before {\n  content: '\\e9bb';\n  margin-left: -1em;\n  color: rgb(255, 227, 177);\n}\n.icon-especiais .path1:before {\n  content: '\\e9bc';\n  color: rgb(178, 180, 185);\n}\n.icon-especiais .path2:before {\n  content: '\\e9bd';\n  margin-left: -1em;\n  color: rgb(190, 190, 190);\n}\n.icon-especiais .path3:before {\n  content: '\\e9be';\n  margin-left: -1em;\n  color: rgb(190, 190, 190);\n}\n.icon-especiais .path4:before {\n  content: '\\e9bf';\n  margin-left: -1em;\n  color: rgb(178, 180, 185);\n}\n.icon-especiais .path5:before {\n  content: '\\e9c0';\n  margin-left: -1em;\n  color: rgb(178, 180, 185);\n}\n.icon-especiais .path6:before {\n  content: '\\e9c1';\n  margin-left: -1em;\n  color: rgb(255, 248, 236);\n}\n.icon-especiais .path7:before {\n  content: '\\e9c2';\n  margin-left: -1em;\n  color: rgb(255, 248, 236);\n}\n.icon-especiais .path8:before {\n  content: '\\e9c3';\n  margin-left: -1em;\n  color: rgb(255, 197, 23);\n}\n.icon-especiais .path9:before {\n  content: '\\e9c4';\n  margin-left: -1em;\n  color: rgb(0, 0, 0);\n}\n.icon-especiais .path10:before {\n  content: '\\e9c5';\n  margin-left: -1em;\n  color: rgb(89, 90, 92);\n}\n.icon-especiais .path11:before {\n  content: '\\e9c6';\n  margin-left: -1em;\n  color: rgb(89, 90, 92);\n}\n.icon-especiais .path12:before {\n  content: '\\e9c7';\n  margin-left: -1em;\n  color: rgb(89, 90, 92);\n}\n.icon-bloqueado .path1:before {\n  content: '\\e9c8';\n  color: rgb(155, 230, 222);\n}\n.icon-bloqueado .path2:before {\n  content: '\\e9c9';\n  margin-left: -1em;\n  color: rgb(69, 208, 193);\n}\n.icon-bloqueado .path3:before {\n  content: '\\e9ca';\n  margin-left: -1em;\n  color: rgb(219, 246, 243);\n}\n.icon-amigos .path1:before {\n  content: '\\e9cb';\n  color: rgb(155, 230, 222);\n}\n.icon-amigos .path2:before {\n  content: '\\e9cc';\n  margin-left: -1em;\n  color: rgb(155, 230, 222);\n}\n.icon-amigos .path3:before {\n  content: '\\e9cd';\n  margin-left: -1em;\n  color: rgb(69, 208, 193);\n}\n.icon-amigos .path4:before {\n  content: '\\e9ce';\n  margin-left: -1em;\n  color: rgb(69, 208, 193);\n}\n.icon-agua:before {\n  content: '\\e9cf';\n  color: #76d3f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
